import React, { useEffect, useRef, useState } from 'react';
import close from '../../assets/icons/close.svg';
import next from '../../assets/icons/icon.svg';
import exporticon from '../../assets/icons/export-data.svg';
import useAutoFocus from '../../Utils/autoFocus';
import Select from 'react-select';
import ConfirmationModal from './ConfirmationModal';
import { getData, Postdataform, PostFileData } from '../../API/GlobalApi';
import Notifier from '../../Utils/notify';
import { reactSelectStyles } from '../../Utils/selectBoxStyle';


export const UploadLibraryNocsData = ({ isOpen, onClose, getContestDatas, currentPage, setRefreshKey }) => {

    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState([]);






    const handleClose = () => {
        setFile(null);

        setErrors([]);
        setLoading(false);
        onClose();
    };

    if (!isOpen) return null;

    const handleUpload = async () => {
        if (!file) return;

        try {
            setLoading(true);
            setErrors([]);

            const formData = new FormData();
            formData.append("file", file);
            // // ✅ LOG PAYLOAD
            // console.log("Upload Payload:");
            // for (let [key, value] of formData.entries()) {
            //     console.log(key, value);
            // }

            const res = await Postdataform(
                "academics/activities/upload-library-noc/",
                formData
            );
            console.log("resposne", res);

            // if (res?.error) {
            //     setErrors([res.error]);
            //     return; // 🚫 STOP here, modal will NOT close
            // }

            if (res?.error) {
                const detailErrors = res?.details?.length
                    ? res.details
                    : [res.error];

                setErrors([res.error, ...(res.details || [])]);
                return; // 🚫 STOP here
            }
            // ❌ NO successful uploads → DO NOT CLOSE MODAL
            // if (!res?.successful_count || res.successful_count === 0) {
            //     const failedErrors =
            //         res?.failed_rows?.map(
            //             (item) => `Row ${item.row}: ${item.error}`
            //         ) || ["Upload failed."];

            //     setErrors(failedErrors);
            //     return; // 🚫 stop here
            // }

            if (res?.message?.toLowerCase().includes("success")) {
                Notifier.success(res.message);
                setRefreshKey(prev => prev + 1);
                handleClose();
            } else {
                setErrors([res.message]);
            }
            // Notifier.success(
            //     `Upload successful! ${res.successful_count} of ${res.total_rows} participants were uploaded to ${res.contest_name}.`
            // );

            // setRefreshKey(prev => prev + 1)
            // ✅ REFRESH TABLE DATA
            // await getContestDatas(
            //     currentPage,
            //     undefined,
            //     undefined,
            //     undefined,
            //     true // 🔥 force = true
            // );
            // ✅ success case
            // console.log("Upload success:", res);
            // handleClose(); // ✅ safe close

        } catch (err) {
            console.error("Upload failed:", err);

            // fallback error handling
            if (err?.errors) {
                setErrors(err.errors);
            } else {
                setErrors(["Something went wrong. Please try again."]);
            }
        } finally {
            setLoading(false);
        }
    };


    const downloadTemplate = () => {
        const link = document.createElement("a");
        link.href = "/Library_NOC_Template.xlsx";
        link.download = "Library_NOC_Template.xlsx";
        link.click();
    };

    const isDisabled = !file || loading;

    return (
        <div className="modal-overlay">
            <div className="modal-content custom-modal-content"
                style={{
                    minHeight: "370px",   // 🔒 prevents shrinking/growing
                    display: "flex",
                    flexDirection: "column",
                }}>
                <div className="modal-header-content d-flex justify-content-between align-items-center mb-3" style={{ zIndex: '-1' }}>
                    <h2 className="text-primary">Upload Libray NOC Data</h2>
                    <button className="close-btn" onClick={handleClose}>
                        <img src={close} alt="close" />
                    </button>
                </div>

                <div className="modal-body custom-modal-body" style={{ flex: 1 }}>
                    {/* Download Template Section */}
                    {/* Download Template Section */}
                    <div className="row mb-3">
                        <div className="col-md-12">
                            <div
                                className="d-flex align-items-center justify-content-between"
                                style={{
                                    padding: "10px 12px",
                                    border: "1px dashed #7F56DA",
                                    borderRadius: "6px",
                                    backgroundColor: "#F9F5FF"
                                }}
                            >
                                <div>
                                    <p style={{ margin: 0, fontWeight: 500, color: "#344054" }}>
                                        Download Excel Template
                                    </p>
                                    <small style={{ color: "#667085" }}>
                                        Use this template to upload library NOC data
                                    </small>
                                </div>

                                <button
                                    type="button"
                                    onClick={downloadTemplate}
                                    style={{
                                        height: "36px",
                                        padding: "0 12px",
                                        borderRadius: "6px",
                                        border: "1px solid #7F56DA",
                                        background: "transparent",
                                        color: "#7F56DA",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px"
                                    }}
                                >
                                    <img src={exporticon} alt="Download" style={{ height: "18px" }} />
                                    Download
                                </button>
                            </div>
                        </div>
                    </div>




                    {/* Upload Section */}
                    <div className="row mt-3">
                        <div className="col-md-8">
                            <label className="form-labell">Upload Library NOC Data <span className="astrisk">*</span></label>
                            <input
                                type="file"
                                accept=".xls,.xlsx"
                                className="form-control"
                                onChange={(e) => setFile(e.target.files[0])}
                            />
                        </div>
                    </div>



                    <div className="row mt-2" style={{ minHeight: "24px" }}>
                        <div className="col-md-12 text-danger">
                            {errors.map((err, i) => (
                                <div key={i}>{err}</div>
                            ))}
                        </div>
                    </div>


                    {/* Submit */}
                    <div className="row mt-4 d-flex justify-content-end">
                        <div className="col-md-3 d-flex justify-content-end">
                            <button
                                className="add-btn"
                                disabled={isDisabled}
                                onClick={handleUpload}
                                style={{
                                    height: "42px",            // ✅ FIXED HEIGHT
                                    minWidth: "130px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: isDisabled ? "not-allowed" : "pointer",
                                    backgroundColor: isDisabled ? "#d3d3d3" : "#7F56DA",
                                }}
                            >
                                {loading ? (
                                    <span className="spinner-border spinner-border-sm" role="status" />
                                ) : (
                                    "Upload Data"
                                )}
                            </button>

                        </div>
                    </div>
                </div>
            </div>

            {/* <ConfirmationModal
                isOpen={showConfirmModal}
                title="Confirm Upload"
                message="Are you sure you want to upload the selected fee file?"
                onCancel={() => setShowConfirmModal(false)}
                onConfirm={() => {
                    handleSubmitFee();
                    setShowConfirmModal(false);
                }}
            /> */}
        </div>
    );
};
